import { render, staticRenderFns } from "./pill-button.vue?vue&type=template&id=0b6d46ab&scoped=true&"
import script from "./pill-button.vue?vue&type=script&lang=js&"
export * from "./pill-button.vue?vue&type=script&lang=js&"
import style0 from "./pill-button.vue?vue&type=style&index=0&id=0b6d46ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d46ab",
  null
  
)

export default component.exports